import React from 'react';
import PropTypes from 'prop-types';

// components
import ComponentLoader from '../../../global/ComponentLoader/ComponentLoader';

function importFunc() {
    return import(/* webpackChunkName: "PdpRespNotificationSaveToFolderCallout" */
    './PdpRespNotificationSaveItemCallout').then(moduleExport => moduleExport.default);
}

const PdpRespNotificationSaveItemCalloutLoader = props => {
    return (
        <ComponentLoader
            {...props}
            useLoadingComponent={false}
            importFunc={importFunc}
            load={props.isEnabled}
        />
    );
};

PdpRespNotificationSaveItemCalloutLoader.propTypes = {
    isEnabled: PropTypes.bool.isRequired,
};

export default PdpRespNotificationSaveItemCalloutLoader;
